import React from "react";
import Avatar from "@mui/material/Avatar";
import {
  ListItemIcon,
  ListItemText,
  ThemeProvider,
  Typography,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { useNavigate } from "react-router-dom";
import JumboDdPopover from "@jumbo/components/JumboDdPopover";
import Div from "@jumbo/shared/Div";
import useJumboTheme from "@jumbo/hooks/useJumboTheme";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { deepOrange } from "@mui/material/colors";
import { ROUTES } from "app/utils/constants/routeConstants";

const AuthUserDropdown = () => {
  const navigate = useNavigate();
  const { theme } = useJumboTheme();
  const { authUser, setAuthToken } = useJumboAuth();

  const onLogout = () => {
    setAuthToken(null);
    navigate(`${ROUTES.USER_LOGIN}`);
  };

  if (authUser === null) {
    return <ThemeProvider theme={theme}></ThemeProvider>;
  } else {
    return (
      <ThemeProvider theme={theme}>
        <JumboDdPopover
          triggerButton={
            <Avatar
              src={authUser.imageUrl || ""}
              sizes={"small"}
              sx={{
                boxShadow: 25,
                cursor: "pointer",
                bgcolor: deepOrange[500],
              }}
            >
              {authUser.login.charAt(0).toUpperCase()}
            </Avatar>
          }
        >
          <Div
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              p: (theme) => theme.spacing(2.5),
            }}
          >
            <Avatar
              alt={authUser.firstName + " " + authUser.lastName}
              src={authUser.imageUrl || ""}
              sx={{ width: 60, height: 60, mb: 2, bgcolor: deepOrange[500] }}
            >
              {authUser.login.charAt(0).toUpperCase()}
            </Avatar>

            <Typography variant={"h5"}>
              {authUser.firstName && authUser.lastName !== null
                ? `${authUser.firstName} ${authUser.lastName}`
                : authUser.login}
            </Typography>
            <Typography variant={"body1"} color="text.secondary">
              {authUser.email}
            </Typography>
          </Div>
          <Divider />
          <nav>
            <List disablePadding sx={{ pb: 1 }}>
              <ListItemButton>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <PersonOutlineIcon />
                </ListItemIcon>
                <ListItemText primary="Profile" sx={{ my: 0 }} />
              </ListItemButton>
              <ListItemButton
                onClick={() => {
                  navigate(`${ROUTES.UPGRADE}`);
                }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <CreditCardIcon />
                </ListItemIcon>
                <ListItemText primary="Upgrade" sx={{ my: 0 }} />
              </ListItemButton>
              <ListItemButton onClick={onLogout}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <LogoutIcon />
                </ListItemIcon>
                <ListItemText primary="Logout" sx={{ my: 0 }} />
              </ListItemButton>
            </List>
          </nav>
        </JumboDdPopover>
      </ThemeProvider>
    );
  }
};

export default AuthUserDropdown;
